var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWindAnim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "meteoconsWind0",
    viewBox: "0 0 342 234"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeDasharray: 148,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 18,
    d: "M264.2 21.3A40 40 0 1 1 293 89H9"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    dur: "12s",
    repeatCount: "indefinite",
    values: "0; 2960"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeDasharray: 110,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 18,
    d: "M148.2 212.7A40 40 0 1 0 177 145H9"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    dur: "12s",
    repeatCount: "indefinite",
    values: "0; 1540"
  }))))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    width: 342,
    height: 234,
    href: "#meteoconsWind0",
    transform: "translate(85 139)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindAnim);
export default __webpack_public_path__ + "static/media/windAnim.306f5e7a1c372527a4c8e4981888ea4b.svg";
export { ForwardRef as ReactComponent };